import { alpha, Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      padding: 12,
      width: '100%',
      background: colorsPalette.violetAnalyticsCard,
      borderRadius: '0px 0px 10px 10px',
      display: 'flex',
      alignItems: 'flex-start',
      flexDirection: 'column',
      position: 'relative',
      [theme.breakpoints.up('md')]: {
        padding: 24,
        flexDirection: 'row',
        alignItems: 'center',
      },
    },
    icon: {
      width: 16,
      minWidth: 16,
      height: 16,
      position: 'relative',
    },
    leftIcon: {
      marginLeft: 8,
      marginBottom: 2,
    },
    rightIcon: {
      marginRight: 8,
      marginBottom: 2,
    },
    videosSwitcher: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
    },
    videosTitle: {
      color: colorsPalette.gray,
      zIndex: 0,
      fontWeight: 700,
      marginBottom: 3,
      fontSize: 16,
      lineHeight: 1,
      position: 'absolute',
      width: '100%',
      textAlign: 'center',
      [theme.breakpoints.up('md')]: {
        marginBottom: 2,
        fontSize: 18,
      },
    },
    leftVideosTitlePlaceholder: {
      marginRight: 'auto',
    },
    rightVideosTitlePlaceholder: {
      marginLeft: 'auto',
    },
    navWrap: {
      width: '100%',
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    iconLink: {
      display: 'flex',
      alignItems: 'center',
      color: colorsPalette.gray,
      fontSize: 16,
      lineHeight: 1,
      fontWeight: 700,
      [theme.breakpoints.up('md')]: {
        fontSize: 18,
      },
      '&:hover > $iconWrap': {
        backgroundColor: alpha(colorsPalette.white, 0.08),
        borderRadius: '50%',
      },
    },
    iconWrap: {
      padding: SMALL_MARGIN / 2,
      height: 34,
    },
    testInfo: {
      flex: 1,
      [theme.breakpoints.up('md')]: {
        marginLeft: SMALL_MARGIN / 2,
      },
    },
  }),
);

export default useStyles;
